import { render, staticRenderFns } from "./MaterialDesignIcons.component.vue?vue&type=template&id=6a8e30a8&"
import script from "./MaterialDesignIcons.component.vue?vue&type=script&lang=ts&"
export * from "./MaterialDesignIcons.component.vue?vue&type=script&lang=ts&"
import style0 from "./MaterialDesignIcons.component.vue?vue&type=style&index=0&id=6a8e30a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports